export default __webpack_public_path__ + "static/media/lemon_shop.0ea50989.svg";